import {AiTextPromptBoxPanel} from '@Panels/ai-text-prompt-box-panel/ai-text-prompt-box-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {PANEL_ID} from '@Panels/ai-text-prompt-box-panel/ai-text-prompt-box-panel.types';
import type {AiTextPromptBoxProps} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';

export default AiTextPromptBoxPanel;

export const openAiTextPromptBoxModal = ({...props}: AiTextPromptBoxProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AI_TEXT_PROMPT_BOX_MODAL,
      panelProps: {
        panelId: PANEL_ID,
        modalId: MODALS_IDS.AI_TEXT_PROMPT_BOX_MODAL,
        dialogMode: true,
        ...props,
      },
    })
  );
};
